import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { IntlProvider } from "react-intl";
import { fetchConfig, getConfig, fetchConfigEnded } from "../modules/configuration";
import { getLocale, getMessages, setLocale } from "../modules/language";
import { LoadingSpinner, GatewayError } from "../components";
import { MainContent } from "./MainContent";

export const Index = () => {
  const dispatch = useDispatch();
  const config = useSelector(getConfig);
  const fetchEnded = useSelector(fetchConfigEnded);
  const messages = useSelector(getMessages);
  const locale = useSelector(getLocale);
  const [waitingComplete, setWaitingComplete] = useState(false);

  useEffect(() => {
    if (!config && !fetchEnded) dispatch(fetchConfig());
    // eslint-disable-next-line
  }, [config, fetchEnded]);

  useEffect(() => {
    if (config) {
      if (!locale) dispatch(setLocale(config.defaultLanguage));
      if (messages != null && !waitingComplete) setWaitingComplete(true);
      if (!waitingComplete) {
        const timeout = setTimeout(() => {
          setWaitingComplete(true);
        }, 1000);
        return () => clearTimeout(timeout);
      }
    }
    // eslint-disable-next-line
  }, [config, fetchEnded, locale, waitingComplete, messages]);

  return (
    <>
      {waitingComplete && (
        <IntlProvider messages={messages} locale={locale.replace("_", "-")}>
          <GatewayError />
          <MainContent />
        </IntlProvider>
      )}
      <LoadingSpinner loading={!waitingComplete} />
    </>
  );
};
